import { SVGProps } from 'react';

interface ExpandProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Expand/fullscreen icon (four outward-pointing corner arrows).
 * TODO: Move to @raydiant/raydial when ready.
 */
const Expand = ({ size = 14, ...props }: ExpandProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.25 0C4.65625 0 5 0.34375 5 0.75C5 1.1875 4.65625 1.5 4.25 1.5H1.5V4.25C1.5 4.6875 1.15625 5 0.75 5C0.3125 5 0 4.6875 0 4.25V0.75C0 0.34375 0.3125 0 0.75 0H4.25ZM0 9.75C0 9.34375 0.3125 9 0.75 9C1.15625 9 1.5 9.34375 1.5 9.75V12.5H4.25C4.65625 12.5 5 12.8438 5 13.25C5 13.6875 4.65625 14 4.25 14H0.75C0.3125 14 0 13.6875 0 13.25V9.75ZM13.25 0C13.6562 0 14 0.34375 14 0.75V4.25C14 4.6875 13.6562 5 13.25 5C12.8125 5 12.5 4.6875 12.5 4.25V1.5H9.75C9.3125 1.5 9 1.1875 9 0.75C9 0.34375 9.3125 0 9.75 0H13.25ZM12.5 9.75C12.5 9.34375 12.8125 9 13.25 9C13.6562 9 14 9.34375 14 9.75V13.25C14 13.6875 13.6562 14 13.25 14H9.75C9.3125 14 9 13.6875 9 13.25C9 12.8438 9.3125 12.5 9.75 12.5H12.5V9.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Expand;
